import axios from 'axios';

// 프로덕션: Nginx 리버스 프록시 사용 (baseURL 비워둠)
// 개발: localhost:8080 직접 연결
const API_URL = '';  // 하드코딩: 항상 상대 경로 사용

// Axios 인스턴스 생성
const http = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터: JWT 토큰 추가
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터: 에러 처리
http.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    
    // 401(Unauthorized) 또는 403(Forbidden) - 인증/권한 실패
    if (status === 401 || status === 403) {
      // 로그인 페이지에서는 처리하지 않음
      const currentPath = window.location.pathname;
      if (currentPath === '/login' || currentPath === '/signup') {
        return Promise.reject(error);
      }
      
      // 인증 실패 시 로그아웃
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      
      // 전역 이벤트 발생 (AuthContext에서 감지)
      window.dispatchEvent(new CustomEvent('auth:logout', {
        detail: { reason: 'token_expired' }
      }));
      
      // 현재 페이지 URL 저장 (로그인 후 복귀용)
      const fullPath = window.location.pathname + window.location.search;
      sessionStorage.setItem('redirectAfterLogin', fullPath);
      
      // 사용자에게 알림
      alert('⏰ 로그인이 만료되었습니다.\n다시 로그인해주세요.');
      
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default http;

